import { IRootState } from '../../app/store';

export const selectCheckIfUserIsRegisteredAsyncStatus = (state: IRootState) =>
    state.register.checkIfUserIsRegisteredAsyncStatus;
export const selectCheckIfUserIsRegistered = (state: IRootState) =>
    state.register.checkIfUserIsRegistered;
export const selectRegisterUserAsyncStatus = (state: IRootState) =>
    state.register.registerUserAsyncStatus;
